import React from "react";
import list from "javascriptstuff-db/react-components";

import Page from "../../components/common/Page";
import ListPageContainer from "../../components/list/ListPageContainer";
import StyledTextBlock from "../../components/common/StyledTextBlock";
import addNotes from "../../logic/addNotes";

const extendedList = addNotes(list, {
  "airbnb/react-dates": `This library depends on momentjs, which is a fairly large library. If you are not already using moment, this small component could generate a large increase in your bundle size.`
});

export default () => (
  <Page>
    <ListPageContainer list={extendedList}>
      <StyledTextBlock>
        <p>
          Components are the building blocks of React apps. These projects
          include components that you can use in your own app.
        </p>
        <p>
          Try filtering on the <a href="#tag:toolkit">toolkit</a> tag to see the
          bigger component libraries. Or check out all the{` `}
          <a href="#tag:'text editor'">text editor</a> or{` `}
          <a href="#tag:calendar">calendar</a> components.
        </p>
      </StyledTextBlock>
    </ListPageContainer>
  </Page>
);



// WEBPACK FOOTER //
// ./src/pages/list/react-components.js